
import Vue from "vue";
import Component from "vue-class-component";

import DetailsParticipant from "./DetailsParticipant.vue";

import { ParticipantInscription } from "@/shared/logic/types";
import { scrollToError } from "../../../../shared/utils";
import { C } from "../controller";

const TabPartsProps = Vue.extend({
  props: {
    outerParticipants: Array as () => ParticipantInscription[] | null
  },
  model: {
    prop: "outerParticipants",
    event: "change"
  }
});

@Component({
  components: { DetailsParticipant }
})
export default class TabParts extends TabPartsProps {
  validated = false;

  $refs!: {
    bottom: HTMLElement;
    form: HTMLFormElement;
  };

  get participants() {
    return this.outerParticipants || [];
  }

  addParticipant() {
    const nullPart = C.newParticipant();
    this.participants.push(nullPart);
    this.$emit("change", this.participants);
    this.$refs.bottom.scrollIntoView();
  }

  deleteParticipant(i: number) {
    const newParts = this.participants.filter((_, idx) => idx != i);
    this.$emit("change", newParts);
  }

  valid() {
    this.validated = true;
    this.$nextTick(() => {
      const isValid = scrollToError(this.$refs.form);
      if (isValid) {
        this.$emit("goNext");
      }
    });
  }
}
